const SELECTOR = '[data-counter-limit]';

class CharacterLimiter {
  constructor() {
    this.attachEventHandlers();
  }

  attachEventHandlers() {
    $('body').on('cocoon:after-insert', (event, $addedTask) => {
      if ($addedTask.find(SELECTOR).size() > 0) {
        $(document).trigger('init:limiter.nearme', [SELECTOR]);
      }
    });
  }
}

export default CharacterLimiter;



// WEBPACK FOOTER //
// ./src/javascripts/CharacterLimiter.js